export function yearOf(date) {
  return date && date.length >= 4 ? date.slice(0, 4) : null;
}

export function formatRating(rating) {
  return rating ? Number(rating).toFixed(1) : null;
}

export function formatRuntime(minutes) {
  if (!minutes) return null;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}

export function genreNames(genres) {
  return (genres || []).map((g) => g.name).join(", ");
}

export function formatDate(date) {
  if (!date) return null;
  try {
    return new Date(`${date}T00:00:00`).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return date;
  }
}

// Relative label used for Continue Watching rows ("Resume 12:34").
export function minutesLabel(seconds) {
  const s = Math.max(0, Math.floor(seconds || 0));
  const h = Math.floor(s / 3600);
  const m = Math.round((s % 3600) / 60);
  if (h > 0) return `${h}h ${m}m`;
  return `${Math.max(1, m)}m`;
}